// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const BurnOnReadSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '270'}
        height={props.height ? props.height.toString() : '164'}
        viewBox='0 0 270 164'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            width='76.5333'
            height='63.1704'
            rx='3.66373'
            transform='matrix(1 0 0 -1 23.3926 119.052)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            width='76.5333'
            height='63.1704'
            rx='3.66373'
            transform='matrix(1 0 0 -1 169.17 154.281)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M14.8887 29.5156L14.8887 46.1631L203.185 46.1631'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeWidth='1.21481'
            strokeLinecap='round'
        />
        <ellipse
            cx='2.42963'
            cy='2.42963'
            rx='2.42963'
            ry='2.42963'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 12.459 29.1553)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            d='M257.549 138.771L257.549 109.253L228.577 109.253'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeWidth='1.21481'
            strokeLinecap='round'
        />
        <circle
            cx='257.549'
            cy='141.503'
            r='2.73315'
            transform='rotate(180 257.549 141.503)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <rect
            x='46.085'
            y='20.103'
            width='181.46'
            height='118.779'
            rx='6.58104'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='6.58104'
        />
        <g clipPath='url(#clip0_4868_132666)'>
            <rect
                width='167.269'
                height='103.86'
                transform='translate(53.1797 27.7461)'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='53.7627'
                y='27.9404'
                width='54.6667'
                height='103.259'
                fill='var(--indigo-400)'
                fillOpacity='0.16'
            />
            <path
                d='M72.3872 36.2832L92.6616 36.2832'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M72.3872 39.4834L84.125 39.4834'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M115.07 36.8174H140.68'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M58.5151 50.1553H74.5213'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='62.3022'
                cy='36.8696'
                r='5.28167'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='59.8364'
                cy='55.8828'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 55.8828H96.9299'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='126.651'
                cy='53.453'
                r='6.07407'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M136.37 53.4531H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 58.3125H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 48.5938H152.376'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='126.651'
                cy='76.5331'
                r='6.07407'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M136.37 76.5332H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 81.3926H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 71.6738H152.376'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='126.651'
                cy='99.6151'
                r='6.07407'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M136.37 99.6152H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 104.474H200.823'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <path
                d='M136.37 94.7559H152.376'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='59.8364'
                cy='64.3867'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 64.3867H90.5274'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='59.8364'
                cy='74.1035'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 74.1035H100.131'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='59.8364'
                cy='82.6074'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 82.6074H96.9299'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='59.8364'
                cy='91.1122'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 91.1123H90.5274'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
            <circle
                cx='59.8364'
                cy='99.6161'
                r='2.42963'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M67.0518 99.6162H100.131'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeWidth='1.21481'
                strokeLinecap='round'
            />
        </g>
        <path
            opacity='0.16'
            d='M215.941 72.889C235.062 72.889 250.563 57.3881 250.563 38.2668C250.563 19.1454 235.062 3.64453 215.941 3.64453C196.82 3.64453 181.319 19.1454 181.319 38.2668C181.319 57.3881 196.82 72.889 215.941 72.889Z'
            fill='var(--center-channel-color)'
        />
        <path
            d='M215.941 69.2444C235.062 69.2444 250.563 53.7435 250.563 34.6222C250.563 15.5009 235.062 0 215.941 0C196.82 0 181.319 15.5009 181.319 34.6222C181.319 53.7435 196.82 69.2444 215.941 69.2444Z'
            fill='var(--indigo-400)'
        />
        <rect
            x='202.821'
            y='28.1834'
            width='26.24'
            height='21.9881'
            rx='2.55111'
            stroke='var(--center-channel-bg)'
            strokeWidth='1.70074'
        />
        <path
            d='M207.21 29.1559V23.0818C207.21 18.3854 211.017 14.5781 215.714 14.5781H216.169C220.866 14.5781 224.673 18.3854 224.673 23.0818V29.1559'
            stroke='var(--center-channel-bg)'
            strokeWidth='1.70074'
        />
        <defs>
            <clipPath id='clip0_4868_132666'>
                <rect
                    width='167.269'
                    height='103.86'
                    fill='white'
                    transform='translate(53.1797 27.7461)'
                />
            </clipPath>
        </defs>
    </svg>

);

export default BurnOnReadSVG;
